<template>
  <div class="mc-trackvideo-card__no-video-wrapper">
    <div class="mc-trackvideo-card__no-video-content">
      <img width="68" :src="calculatedSrc" />

      <div class="mc-trackvideo-card__no-video-play-button" @click="$emit('play')">
        <i class="mc-icon icon-fill_play" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  emits: ['play'],
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
      isWhitelabel: 'identity/isWhitelabel',
    }),
    calculatedSrc() {
      return this.isWhitelabel()
        ? this.getAsset('secondaryLogo', 'sidebarMinimize')
        : require('@/assets/images/mceasy-large.png')
    },
  },
}
</script>

<style lang="scss">
.mc-trackvideo-card__no-video-wrapper {
  height: 100%;
  width: 100%;
  background-color: $blue-900;
  display: flex;
  align-items: center;
  justify-content: center;
  .mc-trackvideo-card__no-video-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    p {
      color: $white;
    }
  }

  .mc-trackvideo-card__no-video-play-button {
    background-color: $white;
    padding: 8px;
    border-radius: 100%;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    i::before {
      font-size: 24px;
    }
  }
}
</style>
